import { CreatorInitialState } from "features/creator/types";

// テンプレートを入れた直後の目印（newComponentIds / newBlockIds）を消す。作品の中身は変えない。
// 以前ここにあった handleAddTemplate は呼び出し元が無く、reducer の中で Blockly のワークスペースを作り
// DOM も触っていたので消した
const reducers = {
  handleClearTemplate(state: CreatorInitialState) {
    state.template = { newComponentIds: [], newBlockIds: [] };
  },
};

export default reducers;
